import { render, staticRenderFns } from "./MainInmobiliaria.vue?vue&type=template&id=dc13301a&scoped=true&"
import script from "./MainInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./MainInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./MainInmobiliaria.vue?vue&type=style&index=0&id=dc13301a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc13301a",
  null
  
)

export default component.exports